module.exports = __webpack_public_path__ + "static/media/icon-archive-white.29b37468.svg";